import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { createDraft } from '@/features/campaignCreatePage/actions';
import { getEditableAttributes } from '@/features/campaignCreatePage/selectors';
import withAsyncFormik from '@/hocs/withAsyncFormik';

import FirstStep from '../FirstStep/component';
import form from '../FirstStep/form';
import styles from '../FirstStep/styles';

const mapStateToProps = state => ({
  getEditableAttributes: getEditableAttributes(state),
});

const mapDispatchToProps = { onSubmit: createDraft };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncFormik(form),
  withStyles(styles),
)(FirstStep);
